import { FuelRadio, FuelTypography } from '@frete.com/fuel-react'
import styled from 'styled-components'

export const FormWrapper = styled.section`
  height: 100%;
  .grid-container.sc-fuel-grid-container-h {
    margin: 0;
  }
`
export const TitleSession = styled.h2`
  font-style: normal;
  font-size: ${({ theme }) => theme.font.size.m5};
  line-height: ${({ theme }) => theme.font.lineHeight.medium};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`

export const Content = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.km8};
  border: ${({ theme }) => theme.border.width.thinner} ${({theme}) => theme.border.style.solid} ${({ theme }) => theme.color.border.neutral.default};
  border-radius: ${({ theme }) => theme.border.radius.large};
  section {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.km6};
  }
`

export const MainContentWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.km8} ${({ theme }) => theme.spacing.km10};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    padding: ${({ theme }) => theme.spacing.km6} ${({ theme }) => theme.spacing.km8};
  }
`

export const Buttons = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.km4};
`

export const Radio = styled(FuelRadio)`
  label > span > span {
    font-style: normal;
    font-weight: ${({ theme }) => theme.font.weight.medium};
    font-size: ${({ theme }) => theme.font.size.m3};
    line-height: ${({ theme }) => theme.font.lineHeight.medium};
    color: ${({ theme }) => theme.color.text.neutral.strong};
  }
`

export const RangePriceWrapper = styled.div`
  padding: 0px 1px;
  overflow: auto;
  width: 100%;
  display: flex;
  gap: ${({ theme }) => theme.spacing.km5};
`

export const RangePriceItem = styled.div`
  width: 290px;
  height: 230px;
  flex-shrink: 0;
  border: ${({ theme }) => theme.border.width.thinner} ${({theme}) => theme.border.style.solid} ${({ theme }) => theme.color.border.neutral.default};
  border-radius: ${({ theme }) => theme.border.radius.large};
  padding: ${({ theme }) => theme.spacing.km5} ${({ theme }) => theme.spacing.km8};
`

export const RangePriceDiscount = styled(FuelTypography)`
 > p {
   color: ${({ theme }) => theme.color.support.blue.weak};
  }
`

export const RangePriceSelectedInfo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.km5};
  padding: ${({ theme }) => theme.spacing.km10};
  background-color: ${({ theme }) => theme.color.background.neutral.weak};
`